var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "d2-card", attrs: { shadow: "never" } }, [
    _c(
      "div",
      { style: _vm.cardBodyStyle },
      [
        _c("d2-scrollbar", { staticStyle: { height: "300px" } }, [
          _c("div", { style: _vm.scrollInnerStyle }, [_vm._t("default")], 2)
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }